import { apiAsync } from '../../common/helpers'

const queryPaidLeaveLocations = async (props) => {
  const params = {
    pageNumber: props.pageNumber,
    search: (props.searchText) ? props.searchText : '',
    sortOrder: props.sortOptions ? props.sortOptions.direction : '',
    sort: props.sortOptions ? props.sortOptions.field : '',
    filterStates: props.filters.state ? props.filters.state.locale.state : '',
    products: 'paidLeave',
    pageSize: props.rowsPerPage,
    includeLocaleFacets: true,
    includeProductMap: true,
    respectOverrides: true
  }

  const api = `external/companies/${(props.companyId)}/locations`

  const result = await apiAsync({
    api,
    params,
    method: 'GET'
  })

  return result
}


export default queryPaidLeaveLocations
